import { Fragment, useEffect, useRef, useState } from "react";
import { Part } from "./components/part";
import PageHeading from "../../components/__simple/_pageheading";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
// import { PartRating } from "./components/rate";
import config from "../../configuration/config";
import i18n from "i18next";
// import { DropDownInput } from "../../components/_input/_dropdown";
// import { LikeButton } from "../../components/__simple/_likeButton";
import { RatingSection } from "./components/ratingSection";
import { CarSection } from "./components/carSection";
import Breadcrumb from "../../components/__simple/breadcrumb";
import { useDispatch } from "react-redux";
import { changeIcons } from "../../_redux/slices/navSlice";
import { useParams } from "react-router";
import axios from "axios";
import { useTranslation } from "react-i18next";
// import { addToCart } from "../../_functions/cart";
import { useUserCart } from "../../User/hooks/useUserCart";
// import { quantity } from "cart-localstorage";
import { Price } from "../../components/__simple/_price";
import { toast } from "react-toastify";
import _ from "lodash";
import { useUserFavorite } from "../../User/hooks/useUserFavorite";
import { shareMaker } from "../../utils/shareDataMaker";
import { numberFormat } from "../../utils/currencyFormatter";
import CustomTabbyTamara from "../../components/customTabbyTamara";
import SimpleButton from "../../components/_input/SimpleButton";
// import { ServiceBox } from "../../components/serviceBox";
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import AlternativeProductsDrawer from "./components/AlternativeProductsDrawer";
import { Button } from "antd";
import { message } from "antd";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function EpartsDetailPage(props) {
  const { changeFavoriteItemState, isFavoriteItem } = useUserFavorite();

  const { removecartItems, changecartItem } = useUserCart();
  const [lang, setlang] = useState(localStorage.getItem("i18nextLng"));
  const languageDir = "language-" + lang;
  const rateRef = useRef(null);
  const carRef = useRef(null);
  const [car, setCar] = useState("active");
  const [rate, setRate] = useState("hidden");
  const [Ava, SetAva] = useState([]);
  const [Dilev, SetDilev] = useState([]);
  const [counter, setCounter] = useState(1);

  const [openAlternativeDrawer, setOpenlternativeDrawer] = useState(false);

  const [sharerInfo, setSharerInfo] = useState({
    url: "",
    hashTage: "",
    title: "",
  });

  let { ProductId } = useParams();
  const { t: trans } = useTranslation(["eparts", "inputs", "info", "model", "new"]);
  const [PWD, setPWD] = useState([]);
  const [PWR, setPWR] = useState([]);
  const [AttachImg, setiAttch] = useState([]);
  //-------------------------------------------------------------------------
  const [favorite, setFavorite] = useState(false);

  const [indexPanel, setIndexPanel] = useState("1000");
  const [terms, setTerms] = useState("");
  const [checkCompatibility, setCheckCompatibility] = useState({});

  function getpric(NetSalePrice, SalesPriceBefor) {
    if (SalesPriceBefor) {
      return (
        <div className="slide-info-text-price 30 space-x-4 space-x-reverse">
          <span className={"text-14 mx-1"}>{trans("info:product_price")}</span>
          <span className={"price  text-20 mx-2"}>
            <Price price={NetSalePrice} />
          </span>
          <span className={"old-price  text-20 mx-3"}>
            {SalesPriceBefor}
            {trans("common:rial")}
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className={"text-14 mx-3"}>{trans("info:product_price")}</span>
          <span className={"price  text-20"}>
            <Price price={NetSalePrice} />
          </span>
        </div>
      );
    }
  }

  const getPrice = (NetSalePrice, SalesPriceDiscount) => {
    if (SalesPriceDiscount) {
      return (
        <div className="flex space-x-4 space-x-reverse">
          <div className="flex-grow-0 text-start text-4xl font-bold text-primary">
            <Price price={NetSalePrice} />
          </div>
          <div className="flex-grow-0 text-center text-3xl text-red-600 line-through px-8">
            {SalesPriceDiscount}
            {trans("common:rial")}
          </div>
          <div className="w-px h-6 bg-gray-300"></div>

          <div className="flex-grow text-start text-1xl">{trans("eparts:price-includes-VAT")}</div>
        </div>
      );
    } else {
      return (
        <div className="flex space-x-4 space-x-reverse">
          <div className="flex-grow-0 text-start text-4xl font-bold text-primary">
            <Price price={NetSalePrice} />
          </div>

          <div className="w-px h-6 bg-gray-300"></div>

          <div className="flex-grow text-start text-1xl">{trans("eparts:price-includes-VAT")}</div>
        </div>
      );
    }
  };

  const getCatNameUrl = ({ guid }) => {
    // func_GetCatNameByGuidEPart
    try {
      const body = {
        guid: guid,
      };

      axios
        .request({
          url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/func_GetCatNameByGuidEPart`,
          data: body,
          method: "POST",
          responseType: "json",
        })
        .then(function (response) {
          if (response.data && response.data.length > 0) {
            console.info("func_GetCatNameByGuidEPart:data", response.data[0]);
            setCatNameUrl(response?.data[0]);
          }
        })
        .catch(function (error) {
          // console.warn("func_GetNameCatsByIdEPart:catch", error);
          throw error;
        });
    } catch (ex) {
      console.warn("func_GetCatNameByGuidEPart:catch", ex);
      debugger;
    }
  };

  function RequsetProductsWithDetails() {
    const Body = {
      GUID: ProductId,
    };
    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FeatchPartsDetails`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // console.log(response.data.ApiObjectData);
        setTimeout(() => setPWD(response.data), 100);

        if (response.data[0].ProductImage) {
          SetImgMain(
            response.data[0].ProductImage
              ? // ? "data:image/png;base64," + response.data[0].ProductImage
                config.mainURL + response.data[0].ProductImage
              : lang.toLowerCase() === "ar"
                ? "/assets/images/parts/PARTS_TOYOTA-AR-no-img.png"
                : "/assets/images/parts/PARTS_TOYOTA-EN-no-img.png",
          );
        }

        const epartsInfo = response.data[0];
        const _sharerInfo = { ...sharerInfo };

        if (epartsInfo) {
          const { DescriptionAr, DescriptionEn, CategiorAr, CategiorEn, NetSalePrice, ProductID } = epartsInfo;
          const { url, title, hashTag } = shareMaker(`/parts/details/${ProductId}`, `${(DescriptionAr ?? "") + "-" + numberFormat(NetSalePrice ?? 0)}`, "");
          _sharerInfo.title = title;
          _sharerInfo.url = url;
          _sharerInfo.hashTage = hashTag;
          setSharerInfo(_sharerInfo);
          setProductNo(ProductID);
          FeatchPartQty(ProductID);
        }
        getCatNameUrl({ guid: ProductId });
        // setTimeout(() => (RequsetProductsWithAlternatives(response.data[0].ProductID)), 100);
        setTimeout(() => RequsetProductsWithAlternatives(ProductId), 100);
        getTermsPart({ guid: ProductId });
        getCheckCompatiblityEPart({ guid: ProductId });
        setTimeout(() => RequsetAttch(response.data[0].ProductID), 100);
        setTimeout(() => RequsetAva(response.data[0].ProductID), 100);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function RequsetProductsWithAlternatives(ID) {
    // const Body = {
    //     "name": "Site_FeatchPartAlternative",
    //     "values": {
    //         "ProductID": ID
    //     }
    // }
    const Body = {
      // "GUID": "0fff1d04-5bd4-4794-b2c0-8b5e3adaf2d7"
      GUID: ID,
    };
    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_FeatchPartSpecial`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // console.log(response.data.ApiObjectData);
        setTimeout(setPWR(response.data), 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const getTermsPart = ({ guid }) => {
    let body = {
      GUID: guid,
      // "GUID": "0fff1d04-5bd4-4794-b2c0-8b5e3adaf2d7"
    };

    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/func_getTermsPart`,
        data: body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // console.log(response.data.ApiObjectData);
        if (response?.data && response?.data.length > 0) {
          console.log("func_getTermsPart: ", response.data);

          if (lang.toLowerCase() == "ar") {
            if (response?.data[0] && response?.data[0]?.termsAr) setTerms(response?.data[0]?.termsAr);
          } else {
            if (response?.data[0] && response?.data[0]?.termsEn) setTerms(response?.data[0]?.termsEn);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getCheckCompatiblityEPart = ({ guid }) => {
    let body = {
      GUID: guid,
      // "GUID": "0fff1d04-5bd4-4794-b2c0-8b5e3adaf2d7"
    };

    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/func_CheckCompatiblityEPart`,
        data: body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        if (response?.data && response.data.length > 0) {
          console.log("getCheckCompatiblityEPart: ", response.data);
          setCheckCompatibility(response?.data[0]);
        }
      })
      .catch(function (error) {
        console.log("getCheckCompatiblityEPart: ", error);
      });
  };

  function RequsetAttch(ID) {
    const Body = {
      productID: ID,
    };
    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_FeatchPartImage`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // console.log(response.data.ApiObjectData);
        setTimeout(setiAttch(response.data), 1000);
      })
      .catch(function (error) {
        setiAttch([]);
      });
  }

  function RequsetAva(ID) {
    const Body = {
      productID: ProductId,
    };
    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FeatchPartLocations`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // console.log(response.data.ApiObjectData);
        setTimeout(SetAva(response.data), 100);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const [PartQty, setPartQty] = useState(0);
  function FeatchPartQty(ProductID) {
    const Body = {
      productListIds: ProductID,
    };

    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FeatchPartQty`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        console.log("site_FeatchPartQty", response.data);
        const stockList = response.data;
        // ✅ نجمع الكمية من كل الفروع
        const totalQty = stockList.filter((s) => s.ProductID === ProductID).reduce((sum, s) => sum + Number(s.TotalQty), 0);
        // ✅ نجيب أكبر كمية موجودة في فرع واحد
        const maxQty = stockList.length > 0 ? Math.max(...stockList.map((b) => Number(b.TotalQty))) : 0;
        setPartQty(maxQty);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  function RequsetDilevaryTime() {
    const Body = {
      ObjectSettings: {
        MetaData: false,
      },
    };

    axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailsWeb_DeliveryTime`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        // console.log(response.data.ApiObjectData);
        setTimeout(SetDilev(response.data.ApiObjectData), 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [DilevryTime, SetDilevry] = useState("");

  function DilevryTimeAccounting(option) {
    console.log(option);
    let dateNow = new Date();
    const Div = Dilev.find((f) => f.DeliveryTimeId === option.value);
    if (option && option.value !== "0") {
      dateNow.setDate(Div.NumberDays);
    }

    if (lang === "en") {
      SetDilevry("day/s:" + dateNow.getDate() + ":hour:" + Div.NumbeHours);
    } else {
      SetDilevry(dateNow.getDate() + "ايام/يوم:" + ":" + Div.NumbeHours + "-ساعة");
    }
  }

  const dispatch = useDispatch();

  useEffect(() => {
    handleCalculateRatingStars();
    RequsetProductsWithDetails();
    RequsetDilevaryTime();
  }, [ProductId]);

  useEffect(() => {
    dispatch(changeIcons({ iconsBlack: true }));

    return () => {
      dispatch(changeIcons({ iconsBlack: false }));
    };
  }, []);

  const [favoriteProducts, setFavoriteProducts] = useState([]);
  // to fetch the user favorites
  const fetchUserFavorites = async () => {
    let _favorites = [];
    try {
      const isLogin = getData("isAuthenticated");
      if (isLogin) {
        const { id } = JSON.parse(getData(User_Data_Key, true));
        const userID = Number(id.toString().split("_")[1]);
        const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchUserFavorites`, {
          userID: userID,
        });
        if (response.status == 200) {
          const favorites = response.data;
          _favorites = _favorites.concat(favorites);
        }
      }
    } catch (err) {
      console.log(err);
    }
    return _favorites;
  };

  useEffect(() => {
    const results = fetchUserFavorites();
    setFavoriteProducts(results);
  }, []);

  function show(section) {
    setCar("hidden");
    setRate("hidden");
    switch (section) {
      case "car":
        setCar("active");
        break;
      case "rate":
        setRate("active");
        break;
      default:
        setCar("active");
    }
  }

  function count(num) {
    if (num === -1 && counter > 1) setCounter(counter + num);
    else if (num === 1 && counter < 100) setCounter(counter + num);
  }

  const [imagePath, SetImgMain] = useState(lang.toLowerCase() == "ar" ? "/assets/images/parts/PARTS_TOYOTA-AR-no-img.png" : "/assets/images/parts/PARTS_TOYOTA-EN-no-img.png");
  //-------------------------------------------------------------------
  const [locationName, setLocationName] = useState("");
  const [locationDistance, setLocationDistance] = useState(null);
  const [showSharers, setShowSharers] = useState(false);
  const [productNo, setProductNo] = useState("");
  const [ratingValues, setRatingValues] = useState({
    stars: 0,
    comments: 0,
  });

  const [catNameUrl, setCatNameUrl] = useState({});
  // to calculate the distance bewtten two coordinates points
  const handleGetDistance = (value) => {
    try {
      if (value == "" || value == "0") {
        setLocationName("");
        setLocationDistance(null);
        return;
      }
      const { Address, Longitude, Latitude } = Ava.find((item) => {
        return item.GUID == value;
      });
      if (navigator.onLine) {
        if (Latitude != null && Longitude != null) {
          navigator.geolocation.getCurrentPosition((position) => {
            const currentPosition = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            const result = getDistance(Latitude, currentPosition.lat, Longitude, currentPosition.lng).toFixed(5);
            setLocationDistance(result);
          });
        } else {
          setLocationDistance(null);
        }
      } else {
        toast.warning(trans("info:no_internet_connect"));
      }
      setLocationName(Address ?? "");
    } catch (error) {
      console.log(error);
    }
  };
  // to calculate the distance
  const getDistance = (lat1, lat2, long1, long2) => {
    const y = Math.abs(lat2 - lat1);
    const x = Math.abs(long2 - long1);
    return Math.sqrt(x * x + y * y);
  };
  // to share the product
  const handleShareItem = () => {
    setShowSharers(!showSharers);
  };
  // to calculate ratings
  const handleCalculateRatingStars = () => {
    axios
      .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchRatingStarsBySparePartProduct`, {
        GUID: `${ProductId}`,
      })
      .then((response) => {
        const value = { ...ratingValues };
        const ratingsGroupsData = response.data;
        const results = ratingsGroupsData.map((item) => {
          return { star: item.Stars, total: item.Total, spe: item.Stars * item.Total, comments: item.Comments };
        });
        const totalComments = Math.ceil(
          _.sum(
            results.map((item) => {
              return item.comments;
            }),
          ) / 2,
        );
        const totalOfSpe = _.sum(
          results.map((item) => {
            return item.spe;
          }),
        );
        const totalOfStars = _.sum(
          results.map((item) => {
            return item.total;
          }),
        );
        const finalTotal = Math.floor(totalOfSpe / totalOfStars);
        value.stars = finalTotal;
        value.comments = totalComments;
        setRatingValues(value);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handelAddToCart = ({ part ,PartQty}) => {
    let objectCart = {
      id: part.ProductID,
      productID: part.ProductID,
      name: part.DescriptionAr,
      nameEn: part.DescriptionEn,
      price: part.NetSalePrice,
      image: imagePath,
      Type: "part",
    };

    console.log("objectCart: ", objectCart);
    console.log("PartQty: ", PartQty);
    if (PartQty <= 0) {
      message.error({
        content: (
          <div
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}>
            قطعة الغيار غير متوفرة في جميع الفروع
          </div>
        ),
        duration: 3,
      });
      return;
    }
    changecartItem(part?.ProductID, null, null, 1, null, null, objectCart);

    //
    // let objectCart =
    //     part.SalesPriceDiscount > 0
    //         ?
    //         {
    //             id: part?.ProductID,
    //             productID: part?.ProductID,
    //             name: part?.DescriptionAr,
    //             nameEn: part?.DescriptionEn,
    //             price: part?.SalesPriceDiscount,
    //             image: part?.imagePath,
    //             Type: "part",
    //         } :
    //         {
    //             id: part?.ProductID,
    //             productID: part?.ProductID,
    //             name: part?.DescriptionAr,
    //             price: part?.NetSalePrice,
    //             image: imagePath,
    //             Type: "part"
    //         }
    //         changecartItem(part?.ProductID, null, null, 1, null, null, objectCart);
  };

  return (
    <Fragment>
      <div className="container mb-10 mt-xs">
        {catNameUrl?.catId &&
        catNameUrl?.catSubId &&
        catNameUrl?.catSubSubIdd &&
        catNameUrl?.catAr &&
        catNameUrl.catEn &&
        catNameUrl?.subCatAr &&
        catNameUrl?.subCatEn &&
        catNameUrl?.subSubCatAr &&
        catNameUrl?.subSubCatEn ? (
          <Breadcrumb
            className={"mt-16 "}
            links={[
              {
                name: trans("eparts:EpartTitel"),
                to: "/parts",
              },
              {
                name: catNameUrl?.catId ? (lang.toLowerCase() == "ar" ? catNameUrl?.catAr : catNameUrl.catEn) : "",
                // name: trans("eparts:details")
                to: `/parts/sereach?cat=${catNameUrl?.catId}&subCat=null&subSubCat=null`,
              },

              {
                name: catNameUrl?.catId && catNameUrl?.catSubId ? (lang.toLowerCase() == "ar" ? catNameUrl?.subCatAr : catNameUrl?.subCatEn) : "",
                // name: trans("eparts:details")
                to: `/parts/sereach?cat=${catNameUrl?.catId}&subCat=${catNameUrl?.catSubId}&subSubCat=null`,
              },

              {
                name: catNameUrl?.catId && catNameUrl?.catSubId && catNameUrl.catSubSubId ? (lang.toLowerCase() == "ar" ? catNameUrl?.subSubCatAr : catNameUrl?.subSubCatEn) : "",
                // name: trans("eparts:details")
                to: `/parts/sereach?cat=${catNameUrl?.catId}&subCat=${catNameUrl?.catSubId}&subSubCat=${catNameUrl.catSubSubId}`,
              },
              {
                name: lang.toLowerCase() == "en" ? PWD[0]?.DescriptionEn : PWD[0]?.DescriptionAr,
              },
            ]}
          />
        ) : catNameUrl?.catId && catNameUrl?.catSubId && catNameUrl?.catAr && catNameUrl?.catEn && catNameUrl?.subCatAr && catNameUrl?.subCatEn ? (
          <Breadcrumb
            className={"mt-16 "}
            links={[
              {
                name: trans("eparts:EpartTitel"),
                to: "/parts",
              },
              {
                name: catNameUrl?.catId ? (lang.toLowerCase() == "ar" ? catNameUrl?.catAr : catNameUrl.catEn) : "",
                // name: trans("eparts:details")
                to: `/parts/sereach?cat=${catNameUrl?.catId}&subCat=null&SSuPCat=null`,
              },

              {
                name: catNameUrl?.catId && catNameUrl?.catSubId ? (lang.toLowerCase() == "ar" ? catNameUrl?.subCatAr : catNameUrl?.subCatEn) : null,
                // name: trans("eparts:details")
                to: `/parts/sereach?cat=${catNameUrl?.catId}&subCat=${catNameUrl?.catSubId}&subSubCat=null`,
              },

              {
                name: lang.toLowerCase() == "en" ? PWD[0]?.DescriptionEn : PWD[0]?.DescriptionAr,
              },
            ]}
          />
        ) : catNameUrl?.catId && catNameUrl?.catAr && catNameUrl?.catEn ? (
          <Breadcrumb
            className={"mt-16 "}
            links={[
              {
                name: trans("eparts:EpartTitel"),
                to: "/parts",
              },
              {
                name: catNameUrl?.catId ? (lang.toLowerCase() == "ar" ? catNameUrl?.catAr : catNameUrl.catEn) : "",
                // name: trans("eparts:details")
                to: `/sereach?cat=${catNameUrl?.catId}&subCat=null&SSuPCat=null`,
              },

              {
                name: lang.toLowerCase() == "en" ? PWD[0]?.DescriptionEn : PWD[0]?.DescriptionAr,
              },
            ]}
          />
        ) : (
          <Breadcrumb
            className={"mt-16 "}
            links={[
              {
                name: trans("eparts:EpartTitel"),
                to: "/parts",
              },
              // {
              //     name: catNameUrl?.catId
              //         ? lang.toLowerCase() == 'ar' ? catNameUrl?.catAr : catNameUrl.catEn
              //         : ""
              //     // name: trans("eparts:details")
              // },
              {
                name: lang.toLowerCase() == "en" ? PWD[0]?.DescriptionEn : PWD[0]?.DescriptionAr,
              },
            ]}
          />
        )}

        <div className={" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12 gap-x-20 " + languageDir}>
          {/*الصورة*/}
          <div className="part-detail-imgs col-span-1 md:col-span-5 ">
            <div className="part-detail-imgs-main">
              <div className="part-detail-imgs-img">
                <img className={"object-full object-contain"} src={imagePath} alt={imagePath.toString()} loading={"lazy"} onError={(e) => (e.target.style.display = "none")} />
              </div>
            </div>
            {AttachImg && AttachImg.length > 0 && (
              <div className={"part-detail-imgs-others"}>
                {AttachImg.map((Att) => (
                  <div className="part-detail-imgs-img">
                    <img
                      className={"object-full object-contain"}
                      // src={"data:image/png;base64," + Att.ProductImage}
                      src={config.FilePathURL + Att.ProductImage}
                      alt={Att?.ProductImage?.toString()}
                      loading={"lazy"}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </div>
            )}

            {/* اختيار الكمية */}
            <div
              className="   fixed md:static bottom-0 md:bottom-auto inset-x-0 md:inset-x-auto z-50 md:z-auto
              rounded-t-2xl md:rounded-2xl border-t border-gray-300 md:border-0
              bg-white shadow-2xl md:shadow-xl   p-6  md:my-8">
              <div className="w-full flex flex-row md:flex-row md:items-center justify-between gap-x-10">
                <div className="flex items-center mb-6">
                  <div className="w-2 h-16 bg-green-600 rounded-full ml-4"></div>
                  <h2 className="text-5xl md:text-3xl  font-bold text-gray-800"> الكمية</h2>
                </div>
                <div className="flex items-center w-50 md:w-full">
                  <button className="w-12 h-16 flex items-center justify-center bg-gray-300 hover:bg-gray-200 rounded-r-lg rtl:rounded-l-lg transition-colors">
                    <span className="text-5xl md:text-4xl ">-</span>
                  </button>
                  <div className="flex-1 h-16 flex items-center justify-center bg-gray-100 text-5xl md:text-4xl  ">1</div>
                  <button className="w-12 h-16 flex items-center justify-center bg-gray-300 hover:bg-gray-200 rounded-l-lg rtl:rounded-r-lg transition-colors">
                    <span className="text-5xl md:text-4xl ">+</span>
                  </button>
                </div>
              </div>

              <div className="nice-flex nice-flex-col nice-flex-center mt-10 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                <Button
                  block
                  size="large"
                  onClick={() => {
                    setOpenlternativeDrawer(true);
                  }}>
                  {trans("القطع البديلة")}
                </Button>
              </div>
            </div>
          </div>

          {
            //
            PWD.map((D) => {
              return (
                <>
                  {
                    <div className="col-span-1 md:col-span-7">
                      {/* الهيدر الرئيسي */}
                      <div className="mb-8 bg-white rounded-2xl shadow-lg p-6">
                        {!D?.BrandID && (
                          <div className={`text-30 font-bold mb-8 h-16 uppercase ${D?.BrandID == "2" ? "text-black" : D?.BrandID == "1" ? "text-red-600" : "text-red-600"}`}>
                            {D?.BrandID == "2" ? trans("eparts:lexus-key") : D?.BrandID == "1" ? trans("eparts:toyota-key") : trans("eparts:toyota-key")}
                          </div>
                        )}

                        <div className="flex flex-row mb-2 space-x-4 space-x-reverse">
                          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 ">{lang.toLowerCase() == "en" ? D.DescriptionEn : D.DescriptionAr}</h1>
                          <div className="w-px h-8 bg-gray-300"></div>
                          {D.ProductNo && (
                            <span className="mx-3 text-3xl md:text-4xl text-gray font-bold  " dir="ltr">
                              {"#" + D.ProductNo.toString() + ""}
                            </span>
                          )}
                        </div>

                        <div className="flex flex-col md:flex-row md:items-center justify-between">
                          <div className="flex items-center space-x-4 space-x-reverse mb-4 md:mb-0">
                            <div className="flex items-center">
                              <div className="text-2xl font-bold text-green-600">{getPrice(D.NetSalePrice, D.SalesPriceDiscount)}</div>
                            </div>
                          </div>

                          {D.StockTotalQty > 0 ? (
                            <div className="flex items-center">
                              <div className="w-5 h-5 bg-green-700 rounded-full me-2 animate-pulse"></div>
                              <span className="text-gray-600 text-2xl mx-3">متوفر في المخزون</span>
                            </div>
                          ) : (
                            <div className="flex items-center">
                              <div className="w-5 h-5 bg-red-700 rounded-full me-2 animate-pulse"></div>
                              <span className="text-gray-600 text-2xl mx-3"> نفذت من المخزون</span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* قسم الأبعاد */}
                      <div className="bg-white rounded-2xl shadow-lg p-6">
                        <div className="flex items-center mb-6">
                          <div className="w-2 h-8 bg-green-600 rounded-full ml-4"></div>
                          <h2 className="text-2xl font-bold text-gray-800">الأبعاد والمواصفات</h2>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-1 gap-6 space-y-4">
                          {/* الأبعاد الرئيسية */}

                          {[
                            { label: "الطول", value: "mm " + (D.length ? D.length : 0), icon: "📏" },
                            { label: "العرض", value: "mm " + (D.width ? D.width : 0), icon: "📐" },
                            { label: "الارتفاع", value: "mm " + (D.height ? D.height : 0), icon: "📏" },
                            { label: "الوزن", value: "gram " + (D.Weight ? D.Weight : 0), icon: "⚖️" },
                          ].map((item, index) => (
                            <div key={index} className="flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 rounded-xl transition-all duration-200 hover:shadow-md">
                              <div className="flex items-center">
                                <span className="text-2xl ml-3">{item.icon}</span>
                                <span className="text-2xl font-medium text-gray-700">{item.label}</span>
                              </div>
                              <span className="text-2xl font-bold text-gray-900">{item.value}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="offer-button items-cente mt-10 w-100 clearfix grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2">
                        <div className="w-100 ">
                          <SimpleButton
                            classes="btn btn-primary text-white text-20 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                            iconPath={"/assets/icons/cart.svg"}
                            title={PartQty <= 0 ? trans("new:not_available") : trans("info:add_to_cart")}
                            disabled={PartQty <= 0}
                            onClick={() => {
                              handelAddToCart({ part: D ,PartQty:PartQty});
                            }}
                          />
                        </div>

                        <div className="w-100">
                          <SimpleButton
                            classes="btn bg-black hover:bg-gray-800 text-white text-20 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                            iconPath={Boolean(isFavoriteItem(productNo)) ? "/assets/icons/heart.png" : "/assets/icons/heart-white.svg"}
                            title={trans("info:add_favorite")}
                            onClick={(evt) => {
                              changeFavoriteItemState(productNo);
                            }}
                          />
                        </div>

                        <div className="w-100"></div>
                      </div>

                      <div className="">
                        <CustomTabbyTamara price={D.NetSalePrice} />
                      </div>
                    </div>
                  }
                </>
              );

              // if (lang === "en") {
              //     return (
              //         <div className="part-detail-info">
              //             <div className="part-detail-info-num mb-6">
              //                 <span> {trans("eparts:product_id")}: </span>
              //                 <h3 className={"font-bold"}>{D.ProductNo} </h3>
              //
              //             </div>
              //
              //             <div className="part-detail-info-desc">
              //                 <p className="text-20">{D.DescriptionEn}</p>
              //             </div>
              //
              //             <div className="part-detail-info-rate my-6">
              //                 <PartRating
              //                     readonly={true}
              //                     intialValue={ratingValues.stars}
              //                 />
              //                 <div className="rating-info">
              //                     <span className={"text-16 text-gray-dark"}>{ratingValues.stars}</span>
              //                     <div className={"rating-divider"}></div>
              //
              //                     <div className={'text-16 text-gray-dark'}>
              //                         {ratingValues.comments} {trans("eparts:mkj")}
              //                     </div>
              //                 </div>
              //             </div>
              //
              //             <div className="part-detail-info-price">
              //
              //                 {getpric(D.NetSalePrice, D.SalesPriceDiscount)}
              //             </div>
              //
              //             <div className="part-detail-info-spec py-8">
              //                 <h4 className="text-16 text-gray-dark mb-10">{trans("eparts:Specifications")}</h4>
              //                 <div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:length")}:</div>
              //
              //                         <div
              //                             className="info-spec-value">{D.length} {trans("eparts:mm")}</div>
              //                     </div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:wheth")}:</div>
              //                         <div
              //                             className="info-spec-value">{D.width} {trans("eparts:mm")}</div>
              //                     </div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:height")}:</div>
              //                         <div
              //                             className="info-spec-value">{D.height} {trans("eparts:mm")}</div>
              //                     </div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:Weight")}:</div>
              //                         <div
              //                             className="info-spec-value">{D.Weight} {trans("eparts:mm")}</div>
              //                     </div>
              //                 </div>
              //             </div>
              //
              //         </div>
              //     );
              // } else {
              //     return (
              //         <div className="part-detail-info">
              //
              //             <div className="part-detail-info-num mb-6">
              //                 <span> {trans("eparts:product_id")}: </span>
              //                 <h3 className={"font-bold"}>{D.ProductNo} </h3>
              //
              //             </div>
              //
              //             <div className="part-detail-info-desc">
              //                 <p className="text-20">{D.DescriptionAr}</p>
              //             </div>
              //
              //             {
              //                 // التقييم
              //                 <div className="part-detail-info-rate my-6">
              //
              //                     <PartRating
              //                         readonly={true}
              //                         intialValue={ratingValues.stars}
              //                     />
              //
              //                     <div className="rating-info">
              //                     <span
              //                         className={"text-16 text-gray-dark"}>{ratingValues.stars}</span>
              //                         <div className={"rating-divider"}></div>
              //
              //                         <div className={'text-16 text-gray-dark'}>
              //                             {ratingValues.comments} {trans("eparts:mkj")}
              //                         </div>
              //                     </div>
              //                 </div>
              //             }
              //             <div className="part-detail-info-price">
              //                 <div className="price flex items-center">
              //                     {getpric(D.NetSalePrice, D.SalesPriceDiscount)}
              //                 </div>
              //
              //             </div>
              //             <div className="part-detail-info-spec py-8">
              //                 <h4 className="text-16 text-gray-dark mb-10">{trans("eparts:Specifications")}</h4>
              //                 <div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:length")}:</div>
              //
              //                         <div
              //                             className="info-spec-value">{D.length} {trans("eparts:mm")}</div>
              //                     </div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:wheth")}:</div>
              //                         <div
              //                             className="info-spec-value">{D.width} {trans("eparts:mm")}</div>
              //                     </div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:height")}:</div>
              //                         <div
              //                             className="info-spec-value">{D.height} {trans("eparts:mm")}</div>
              //                     </div>
              //                     <div className={"info-spec"}>
              //                         <div className="info-spec-key">{trans("eparts:Weight")}:</div>
              //                         <div
              //                             className="info-spec-value">{D.Weight} {trans("eparts:mm")}</div>
              //                     </div>
              //                 </div>
              //             </div>
              //
              //         </div>
              //     );
              // }
            })
          }

          {
            // <div className="part-detail-options">
            //     <div className="options">
            //         <div className={`options-like  ${lang == 'ar' ? 'options-like-r' : 'options-like-l'}`}>
            //             <LikeButton
            //                 favorite={Boolean(isFavoriteItem(productNo))}
            //                 long={true}
            //                 onToggle={() => {
            //                     changeFavoriteItemState(productNo)
            //                 }}
            //             />
            //         </div>
            //         <div>
            //             <div className="option-title">   {trans("eparts:dateNithing")}</div>
            //             <DropDownInput
            //                 className={"ml-6 mr-16"}
            //                 options={[
            //                     ...Dilev.map(A => {
            //                         if (lang === "ar") {
            //                             return {value: A.DeliveryTimeId, text: A.SIteNameAr};
            //                         } else {
            //                             return {value: A.DeliveryTimeId, text: A.SiteNameEn};
            //                         }
            //
            //                     })]}
            //                 onfilter={DilevryTimeAccounting}
            //
            //             />
            //             <p className={"mt-6 mx-6 border-radius bg-page py-4 text-16 font-bold pr-4"}>
            //                 {trans("eparts:AccessTo")} {DilevryTime}
            //             </p>
            //         </div>
            //
            //
            //         {PWD.map(WD => (
            //             <div className="bg-page py-4 px-2 my-8 part-detail-options-counter">
            //
            //                 <div className="counter">
            //                     <button className="counter-btn" onClick={() => count(-1)}>-</button>
            //                     <div className="counter-num">{counter}</div>
            //                     <button className="counter-btn" onClick={() => count(+1)}>+</button>
            //                 </div>
            //                 <div
            //                     onClick={() => {
            //
            //                         var objectCart =
            //                             WD.SalesPriceDiscount > 0 ?
            //                                 {
            //
            //
            //                                     id: WD?.ProductID,
            //                                     productID: WD?.ProductID,
            //                                     name: WD?.DescriptionAr,
            //                                     price: WD?.SalesPriceDiscount,
            //                                     image: imagePath,
            //                                     Type: "part"
            //
            //
            //                                     // quantity(  WD.ProductID,counter)
            //                                 }
            //                                 :
            //                                 {
            //
            //                                     id: WD?.ProductID,
            //                                     productID: WD?.ProductID,
            //                                     name: WD?.DescriptionAr,
            //                                     price: WD?.NetSalePrice,
            //                                     image: imagePath,
            //                                     Type: "part"
            //
            //
            //                                     // quantity(  WD.ProductID,counter)
            //                                 }
            //
            //                         changecartItem(WD.ProductID, null, null, counter, null, null, objectCart);
            //
            //
            //                     }}
            //
            //                     className={"btn btn-primary text-14 px-4"}>
            //                     {trans("eparts:AddToCart")}
            //                     <img className={"inline filter-white size-20 pr-1"}
            //                          src="/assets/icons/cart.svg"
            //                          alt="hassan jameel cart "/>
            //                 </div>
            //             </div>
            //         ))}
            //
            //
            //         <div>
            //             <div className="option-title"> {trans("eparts:AvaAtView")}</div>
            //             {
            //
            //                 <DropDownInput
            //                     className={"ml-6 mr-16"}
            //                     options={[
            //                         ...Ava.map(A => {
            //                             if (lang === "ar") {
            //                                 return {value: A.GUID, text: A.SitesDescriptionAr};
            //                             } else {
            //                                 return {value: A.GUID, text: A.SitesDescriptionEn};
            //                             }
            //
            //                         })]}
            //                     onSelect={handleGetDistance}
            //
            //                 />
            //
            //             }
            //
            //             <div className={"part-locations mt-10"}>
            //                 <h3 className={"part-locations-title"}> {trans("eparts:locations-title")}</h3>
            //                 <div className="mx-6 mt-4 part-locations-flex">
            //                     <div>
            //                         <div className={"part-locations-name"}>
            //                             <img className={"filter-primary"} src="/assets/icons/location.svg"
            //                                  alt="location"/>
            //                             <h4 className={"text-16"}>{locationName}</h4>
            //                         </div>
            //                         <div
            //                             className={"part-locations-place mr-16 mt-2  bg-page px-4 py-6 border-radius-sm"}>
            //                             <p className={"text-16"}>
            //                                 {
            //                                     trans("info:ditance_note") + ' ' + (locationDistance ? (String(locationDistance) + ' ' + trans('info:km')) : '')
            //                                 }
            //                             </p>
            //                             <a className={"part-locations-place-link nice-pointer"}
            //                                onClick={handleShareItem}>
            //                                 <img className={"object-full object-contain"}
            //                                      src="/assets/icons/link-new-page.svg" alt=""/>
            //                             </a>
            //
            //                         </div>
            //                         {showSharers &&
            //                             <div className=" my-4  nice-flex nice-flex-row nice-flex-center">
            //                                 <FacebookShareButton
            //                                     url={sharerInfo.url}
            //                                     quote={sharerInfo.title}
            //                                     hashtag={sharerInfo.hashTage}
            //                                 >
            //                                     <FacebookIcon size={36}/>
            //                                 </FacebookShareButton>
            //                                 <TwitterShareButton
            //                                     url={sharerInfo.url}
            //                                     quote={sharerInfo.title}
            //                                     hashtag={sharerInfo.hashTage}
            //                                 >
            //                                     <TwitterIcon size={36}/>
            //                                 </TwitterShareButton>
            //                                 <WhatsappShareButton
            //                                     url={sharerInfo.url}
            //                                     quote={sharerInfo.title}
            //                                     hashtag={sharerInfo.hashTage}
            //                                 >
            //                                     <WhatsappIcon size={36}/>
            //                                 </WhatsappShareButton>
            //                                 <TelegramShareButton
            //                                     url={sharerInfo.url}
            //                                     quote={sharerInfo.title}
            //                                     hashtag={sharerInfo.hashTage}
            //                                 >
            //                                     <TelegramIcon size={36}/>
            //                                 </TelegramShareButton>
            //                                 <EmailShareButton
            //                                     url={sharerInfo.url}
            //                                     quote={sharerInfo.title}
            //                                     hashtag={sharerInfo.hashTage}
            //                                 >
            //                                     <EmailIcon size={36}/>
            //                                 </EmailShareButton>
            //                             </div>}
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="services">
            //         <div className={"service"}>
            //             <img className={"service-img filter-black"} src="/assets/icons/part/secure.svg"
            //                  alt=""/>
            //             <div className="service-text">
            //                 <h4 className={"text-16"}>  {trans("new:locations-shop")}</h4>
            //                 <img className={"info-icon "} src={"/assets/icons/info-primary.svg"}
            //                      alt={"info"}/>
            //             </div>
            //         </div>
            //         <div className={"service"}>
            //             <img className={"service-img filter-black"} src="/assets/icons/part/replace.svg"
            //                  alt=""/>
            //             <div className="service-text">
            //                 <h4 className={"text-16"}> {trans("new:locations-Replace")}</h4>
            //                 <img className={"info-icon "} src={"/assets/icons/info-primary.svg"}
            //                      alt={"info"}/>
            //             </div>
            //         </div>
            //         <div className={"service"}>
            //             <img className={"service-img filter-black"} src="/assets/icons/part/original.svg"
            //                  alt=""/>
            //             <div className="service-text">
            //                 <h4 className={"text-16"}>{trans("new:locations-Advice")}</h4>
            //                 <img className={"info-icon "} src={"/assets/icons/info-primary.svg"}
            //                      alt={"info"}/>
            //             </div>
            //         </div>
            //         <div className={"service"}>
            //             <img className={"service-img filter-black"} src="/assets/icons/part/fast.svg"
            //                  alt=""/>
            //             <div className="service-text">
            //                 <h4 className={"text-16"}>{trans("new:locations-Send")}</h4>
            //                 <img className={"info-icon "} src={"/assets/icons/info-primary.svg"}
            //                      alt={"info"}/>
            //             </div>
            //         </div>
            //     </div>
            // </div>
          }
        </div>
      </div>
      <AlternativeProductsDrawer productId={PWD[0]?.ProductID} open={openAlternativeDrawer} onClose={() => setOpenlternativeDrawer(false)} />
      {
        /*التوافق*/
        checkCompatibility?.CheckCompatibility == true && (
          <div className="part-info-detail bg-white box-shadow py-10 mb-32 w-screen pb-20">
            <div className="part-info-detail-btns mb-10 container">
              <button
                onClick={() => {
                  show("car");
                }}
                className={"text-20 text-gray " + car}>
                {trans("eparts:compatibility")}
              </button>

              {/*todo: التقييم */}
              {/*<button onClick={() => {*/}
              {/*    show("rate")*/}
              {/*}} className={"text-20 text-gray " + rate}>{trans("eparts:oradar")}*/}
              {/*</button>*/}
            </div>

            <div className={car}>
              <div className="container">
                <CarSection guidProductId={ProductId} />
              </div>

              <div className={rate}>
                <RatingSection productID={ProductId} />
              </div>
            </div>
          </div>
        )
      }

      {
        // todo:  الشروط والاحكام

        terms && terms != "" && (
          <div className="container mb-32">
            <div className="panel-section panel-white bg-theme-up w-100">
              <div className={`panel-content   ${indexPanel == "2000" ? "show-panel-info" : ""}`}>
                <div className="panel-content-top px-5" onClick={(e) => setIndexPanel(indexPanel == "2000" ? "000" : "2000")}>
                  {/*<h1 className="text-20 text-super-gray font-bold">{trans("offers:offer")}</h1>*/}
                  <h1 className="text-20 text-super-gray font-bold">{trans("offers:terms")}</h1>
                  <img src="/assets/icons/arrow.svg" alt={"arrow"} loading={"lazy"} onError={(e) => (e.target.style.display = "none")} />
                </div>

                <div className="panel-content-body">
                  <div className="mx-10 my-10">
                    {
                      <div className={"new-lines offer-detail-data"}>
                        <ul>
                          {terms
                            ?.replaceAll("\\n\\n", "\\n")
                            ?.split("\n")
                            ?.map((note, index) => {
                              return note ? (
                                <li key={index} className="text-20">
                                  {/* <span className="text-16 text-gray" >{note}</span> */}
                                  <span className="text-20 " dangerouslySetInnerHTML={{ __html: note }} />
                                </li>
                              ) : null;
                            })}
                        </ul>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        /*منتجات مماثلة*/
        PWR && PWR.length > 0 && (
          <div className="container mb-32">
            <PageHeading title={trans("eparts:similar-products")} />

            <Swiper
              spaceBetween={1}
              slidesPerView={2}
              breakpoints={{
                876: {
                  slidesPerView: 6,
                },
                576: {
                  slidesPerView: 4,
                },
              }}
              pagination={{ clickable: true }}
              className={"mb-16k"}
              resizeObserver={"true"}
              autoplay={false}
              loop={false}
              observer={true}>
              {PWR?.map((catValue, catIndex) => (
                <SwiperSlide className={"px-3"} key={catIndex}>
                  {
                    // <ServiceBox
                    //     titlebtn={trans("eparts:titlebtn_ServiceBox")}
                    //     link={"/parts/group/" + proValue?.GUID}
                    //     imgUrl={proValue.ImageUrl}
                    //     titleEn={proValue?.DescriptionEn}
                    //     titleAr={proValue?.DescriptionAr}
                    // />

                    <Part
                      Engine_Groups={catValue?.CategiorAr}
                      SalesPriceBefor={catValue?.SalesPriceDiscount}
                      GUID={catValue?.GUID}
                      favorites={favoriteProducts}
                      Weight={catValue?.Weight}
                      height={catValue?.height}
                      width={catValue?.width}
                      length={catValue?.length}
                      ProductImage={catValue?.ProductImage}
                      DescriptionEn={catValue?.DescriptionEn}
                      DescriptionAr={catValue?.DescriptionAr}
                      NetSalePrice={catValue?.SalesPrice}
                      ProductID={catValue?.ProductID}
                      ProductNo={catValue?.ProductNo}
                      Qty={catValue.TotalQty}
                    />
                  }
                </SwiperSlide>
              ))}
            </Swiper>
            {/*<div className=" grid-4-cols">*/}
            {/*    {PWR.map(P => (*/}
            {/*        <SwiperSlide className={"px-3"} key={P.ProductID}>*/}

            {/*            <Part Engine_Groups={P.CategiorAr}*/}
            {/*                  SalesPriceBefor={P.SalesPrice}*/}
            {/*                  GUID={P.GUID}*/}
            {/*                  Weight={P.Weight} height={P.height} width={P.width} length={P.length}*/}
            {/*                  ProductImage={P.ProductImage}*/}
            {/*                  DescriptionEn={P.DescriptionEn}*/}
            {/*                  DescriptionAr={P.DescriptionAr}*/}
            {/*                  NetSalePrice={P.SalesPriceDiscount}*/}
            {/*                  ProductID={P.ProductID} ProductNo={P.ProductNo}*/}
            {/*            />*/}
            {/*        </SwiperSlide>*/}
            {/*    ))}*/}
            {/*</div>*/}
          </div>
        )
      }

      {/* {ProductDetails()} */}
    </Fragment>
  );
}
// مكون مساعد لعرض تفاصيل المنتج
const DetailItem = ({ label, value }) => {
  return (
    <div className="flex justify-between items-center py-3 px-4 bg-gray-50 hover:bg-gray-100 rounded-xl transition-colors">
      <span className="font-medium text-gray-700">{label}</span>
      <span className="font-bold text-gray-900">{value}</span>
    </div>
  );
};

const ProductDetails = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-8">
      <div className="max-w-6xl mx-auto">
        {/* الهيدر الرئيسي */}
        <div className="mb-8 bg-white rounded-2xl shadow-lg p-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">زيت دفونس إل تي 75 دبلومة 1 لتر</h1>

          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div className="flex items-center space-x-4 space-x-reverse mb-4 md:mb-0">
              <div className="flex items-center">
                <span className="text-2xl font-bold text-green-600">القيمات 0</span>
              </div>
              <div className="w-px h-6 bg-gray-300"></div>
              <div className="flex items-center">
                <svg className="w-6 h-6 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:0888502906" className="text-xl font-semibold text-gray-700 hover:text-blue-600 transition-colors">
                  0888502906
                </a>
              </div>
            </div>

            <div className="flex items-center">
              <div className="w-3 h-3 bg-green-500 rounded-full mr-2 animate-pulse"></div>
              <span className="text-gray-600">متوفر في المخزون</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* العمود الأيسر: نطاق الاستخدام */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
              <div className="flex items-center mb-6">
                <div className="w-2 h-8 bg-green-600 rounded-full ml-4"></div>
                <h2 className="text-2xl font-bold text-gray-800">نطاق الاستخدام</h2>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="mr-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">هل هذه القطعة مناسبة مع سيارات؟</h3>
                    <p className="text-gray-700 leading-relaxed">نعم، زيت دفونس إل تي 75 دبلومة 1 لتر مصمم خصيصًا ليعمل بكفاءة مع معظم أنواع السيارات الحديثة.</p>
                  </div>
                </div>
              </div>

              {/* أنواع السيارات المتوافقة */}
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">أنواع السيارات المتوافقة:</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {["سيارات سيدان", "سيارات دفع رباعي", "سيارات رياضية", "سيارات عائلية", "سيارات تجارية", "سيارات كهربائية"].map((type, index) => (
                    <div key={index} className="flex items-center p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
                      <svg className="w-5 h-5 text-green-500 ml-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span className="text-gray-700">{type}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* قسم الأبعاد */}
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <div className="flex items-center mb-6">
                <div className="w-2 h-8 bg-green-600 rounded-full ml-4"></div>
                <h2 className="text-2xl font-bold text-gray-800">الأبعاد والمواصفات</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* الأبعاد الرئيسية */}
                <div className="space-y-4">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">القياسات الفنية:</h3>

                  {[
                    { label: "الطول", value: "25 سم", icon: "📏" },
                    { label: "العرض", value: "15 سم", icon: "📐" },
                    { label: "الارتفاع", value: "8 سم", icon: "📏" },
                    { label: "الوزن", value: "0.9 كجم", icon: "⚖️" },
                    { label: "السعة", value: "1 لتر", icon: "💧" },
                    { label: "الكثافة", value: "75W", icon: "🔋" },
                  ].map((item, index) => (
                    <div key={index} className="flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 rounded-xl transition-all duration-200 hover:shadow-md">
                      <div className="flex items-center">
                        <span className="text-xl ml-3">{item.icon}</span>
                        <span className="text-lg font-medium text-gray-700">{item.label}</span>
                      </div>
                      <span className="text-lg font-bold text-gray-900">{item.value}</span>
                    </div>
                  ))}
                </div>

                {/* صورة توضيحية */}
                <div className="flex flex-col items-center justify-center">
                  <div className="w-full h-64 bg-gradient-to-br from-blue-100 to-blue-200 rounded-2xl mb-4 flex items-center justify-center">
                    <div className="text-center">
                      <div className="text-6xl mb-4">🛢️</div>
                      <p className="text-gray-700 font-medium">زيت دفونس إل تي 75</p>
                      <p className="text-gray-600">دبلومة 1 لتر</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-3 w-full">
                    {["أمامي", "جانبي", "علوي"].map((view, index) => (
                      <div key={index} className="bg-gray-100 hover:bg-gray-200 rounded-lg p-3 text-center cursor-pointer transition-colors">
                        <span className="text-gray-700 font-medium">{view}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* العمود الأيمن: الشحن والتسليم */}
          <div>
            <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-8">
              <div className="flex items-center mb-6">
                <div className="w-2 h-8 bg-green-600 rounded-full ml-4"></div>
                <h2 className="text-2xl font-bold text-gray-800">الشحن والتسليم</h2>
              </div>

              {/* معلومات الشحن */}
              <div className="mb-8">
                <p className="text-gray-700 leading-relaxed mb-6 p-4 bg-gray-50 rounded-lg">
                  هذا المنتج متوفر للشحن إلى أي مكان في المملكة العربية السعودية. الوقت المتوقع للتوصيل من 2 إلى 3 أيام، لكن الوقت الفعلي يعتمد على موقع التوصيل.
                </p>

                {/* خيارات الشحن */}
                <div className="space-y-4">
                  <h3 className="font-semibold text-gray-800 mb-3">خيارات الشحن:</h3>

                  <div className="p-4 border border-blue-200 rounded-xl bg-blue-50">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        <svg className="w-5 h-5 text-blue-600 ml-2" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                          <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-1h4v1a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H20a1 1 0 001-1v-7.5a1 1 0 00-1-1h-1.278c-.511 0-1.002-.202-1.364-.556l-1.414-1.414A2.002 2.002 0 0015.056 4H14V2a1 1 0 00-1-1h-3a1 1 0 00-1 1v2H5.5A1.5 1.5 0 004 5.5V6H3a1 1 0 00-1 1v10a1 1 0 001 1z" />
                        </svg>
                        <span className="font-medium text-gray-800">توصيل سريع</span>
                      </div>
                      <span className="text-green-600 font-bold">مجاني</span>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">2-3 أيام عمل</p>
                  </div>

                  <div className="p-4 border border-gray-200 rounded-xl hover:border-blue-300 transition-colors cursor-pointer">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center">
                        <svg className="w-5 h-5 text-gray-600 ml-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        <span className="font-medium text-gray-800">توصيل فائق السرعة</span>
                      </div>
                      <span className="text-gray-800 font-bold">25 ر.س</span>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">24 ساعة</p>
                  </div>
                </div>
              </div>

              {/* معلومات إضافية */}
              <div className="pt-6 border-t border-gray-200">
                <h3 className="font-semibold text-gray-800 mb-4">معلومات إضافية:</h3>

                <div className="space-y-3">
                  {[
                    { text: "ضمان لمدة سنة", icon: "🛡️" },
                    { text: "دعم فني مجاني", icon: "👨‍🔧" },
                    { text: "إرجاع مجاني خلال 14 يوم", icon: "↩️" },
                    { text: "شهادة الجودة متوفرة", icon: "📄" },
                  ].map((item, index) => (
                    <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg">
                      <span className="text-xl ml-3">{item.icon}</span>
                      <span className="text-gray-700">{item.text}</span>
                    </div>
                  ))}
                </div>

                {/* زر الطلب السريع */}
                <button className="w-full mt-8 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center">
                  <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  اطلب الآن
                </button>

                {/* اختيار الكمية */}
                <div className="mb-8">
                  <h3 className="text-lg font-medium text-gray-800 mb-4">الكمية</h3>
                  <div className="flex items-center">
                    <button className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-l-lg transition-colors">
                      <span className="text-xl">-</span>
                    </button>
                    <div className="flex-1 h-12 flex items-center justify-center bg-gray-50 text-xl font-bold">1</div>
                    <button className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-r-lg transition-colors">
                      <span className="text-xl">+</span>
                    </button>
                  </div>
                </div>

                {/* زر الإضافة للسلة */}
                <button className="w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 mb-6 flex items-center justify-center">
                  <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  إضافة إلى السلة
                </button>
                {/* رقم التواصل */}
                <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-xl text-center">
                  <p className="text-gray-700 mb-2">للاستفسارات:</p>
                  <a href="tel:0888502906" className="text-2xl font-bold text-blue-600 hover:text-blue-800 transition-colors">
                    0888502906
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
